import { PropTypes } from 'prop-types';
import { useSelector } from 'react-redux';

const RoleCheck = ({ children, requiredRole }) => {
  // Skip role check when internal ui
  // This flag is set in internal configSlice
  const skipRoleCheck = useSelector(state => state.config.skipRoleCheck) ?? false;
  // Internal ui doesn't have session
  const roles = useSelector(state => state.session?.client?.roles) ?? [];
  if (skipRoleCheck === true) {
    return children;
  }
  return roles !== undefined && roles.includes(requiredRole) ? children : null;
};

RoleCheck.propTypes = {
  children: PropTypes.node,
  requiredRole: PropTypes.string,
};

export { RoleCheck };
